import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  BooleanInput,
  required,
  email,
} from "react-admin";
import { Typography } from "@mui/material";
import { editTitle } from "../../../../customStyles/ra-custom-styles";
import InactiveDeleteOptionEditToolbar from "../../Partials/CustomComponents/InactiveDeleteOptionEditToolbar";

const EditAdministration = () => {
  return (
    <Edit
      title="Потребители"
      mutationMode="pessimistic"
      sx={editTitle}
    >
      <Typography sx={editTitle}>Редакция на потребител </Typography>
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <TextInput
          label="Име"
          source="first_name"
        />{" "}
        <TextInput
          label="Фамилия"
          source="last_name"
        />{" "}
        <TextInput
          label="Парола"
          source="password"
        />
        <TextInput
          label="Телефон"
          source="phone_number"
        />
        <TextInput
          label="E-мейл"
          source="email"
          validate={[required(), email()]}
        />
        <BooleanInput
          label="Лимитиран"
          source="is_limited_to_one_session "
        />
        <BooleanInput
          label="Блокиран"
          source="is_blocked"
        />
        <BooleanInput
          label="Администратор"
          source="is_administrator"
        />
        <ReferenceArrayInput
          source="role_ids"
          reference={"users/roles"}
        >
          <AutocompleteArrayInput
            optionText="name"
            label="Активни права"
            fullWidth
          />
        </ReferenceArrayInput>
      </SimpleForm>
    </Edit>
  );
};

export default EditAdministration;
